import React from 'react';
import MultiStackChart from './echarts/MultiStackChart';

/**
 * @param {string} type type of the chart that will be rendered.
 * where type = bar
 */
function getSimpleCrossChartComponent(type = 'bar') {
  return {
    bar: MultiStackChart,
  }[type];
}

export default function SimpleCrossChart({
  chartFontSize,
  type,
  data,
  colors,
  colorPickerColors,
  legendsFilter,
  legendsFilterHandler,
  theme,
  themeTitle,
  updateSimpleCrossChartColors,
  error,
  chartRef,
}) {
  const SimpleCrossChartComponent = getSimpleCrossChartComponent(type);

  return (
    <SimpleCrossChartComponent
      chartFontSize={chartFontSize}
      updateSimpleCrossChartColors={updateSimpleCrossChartColors}
      data={data}
      colors={colors}
      colorPickerColors={colorPickerColors}
      legendsFilter={legendsFilter.keywords}
      legendsFilterStrategy={legendsFilter.type}
      legendsFilterHandler={legendsFilterHandler}
      theme={theme}
      themeTitle={themeTitle}
      // Se não acrescentar esta linha,
      // ao alterar o tema da aplicacao, ele nao gera
      // uma nova instancia do componente, fazendo com que
      // a configuracoes das fontes das legendas permaneçam com
      // as cores do tema anterior. Dificultando a experiencia do
      // usuario.
      key={`${themeTitle}${error}`}
      error={error}
      chartRef={chartRef}
    />
  );
}
